export default __webpack_public_path__ + "static/media/DinosaurTrain_00.bf5e433c.png";